import { UseQueryModalReturn } from "../../types";

interface UseMultiSelectQueryModalParams<TOperator> {
  selectedIds: (string | number)[];
  previousIds?: (string | number)[];
  selectedOperator?: TOperator | null;
  initialOperator?: TOperator | null;
  editQueryId?: string;
  existingQueryId?: string | null;
}

export function useMultiSelectQueryModal<TOperator>({
  selectedIds,
  previousIds,
  selectedOperator,
  initialOperator,
  editQueryId,
  existingQueryId,
}: UseMultiSelectQueryModalParams<TOperator>): UseQueryModalReturn {
  const hasSameSelection =
    selectedIds.length === previousIds?.length &&
    selectedIds.every((id) => previousIds.includes(id));

  const isSubmitDisabled =
    selectedIds.length === 0 ||
    (!!editQueryId &&
      hasSameSelection &&
      selectedOperator === initialOperator) ||
    (!!existingQueryId && hasSameSelection);

  return { isSubmitDisabled };
}
